'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReadMore = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _i18n = require('../../../../services/i18n');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var ReadMore = exports.ReadMore = function ReadMore(_ref) {
  var charCount = _ref.charCount,
      children = _ref.children;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      showOriginal = _useState2[0],
      setShowOriginal = _useState2[1];

  var isLonger = children.length > charCount;
  var trimmedString = children.substring(0, charCount);
  var message = isLonger ? trimmedString.substr(0, trimmedString.lastIndexOf(' ')) : children;
  var buttonText = showOriginal ? (0, _i18n.t)('products.product.read_less') : (0, _i18n.t)('products.product.read_more');

  (0, _react.useEffect)(function () {
    setShowOriginal(false);
  }, [children]);

  return _react2.default.createElement(_react.Fragment, null, _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: showOriginal ? children : message } }), isLonger && _react2.default.createElement(_react.Fragment, null, _react2.default.createElement('span', null, ' - '), _react2.default.createElement('span', { className: 'util-Cu-po util-Td-u', onClick: function onClick() {
      return setShowOriginal(!showOriginal);
    } }, buttonText)));
};

ReadMore.propTypes = {
  charCount: _propTypes2.default.number.isRequired,
  children: _propTypes2.default.string.isRequired
};